const FAQ = [
  {
    question: "What is earthquake retrofitting and why is it important?",
    answer:
      "Earthquake retrofitting<IN_CITY_ZIP> reinforces your home’s foundation and framing to minimize damage during seismic events. In earthquake-prone areas, retrofitting protects your family, preserves your investment, and helps comply with local building codes.",
  },
  {
    question: "How do I know if my home needs retrofitting?",
    answer:
      "Homes built before 1980<IN_CITY_ZIP> are often not up to current seismic standards. If your home has a raised foundation, unbraced cripple walls, or lacks anchor bolts, it likely needs retrofitting. We offer free inspections to assess your structure and risk level.",
  },
  {
    question: "What does a typical earthquake retrofit include?",
    answer:
      "A standard retrofit<IN_CITY_ZIP> includes foundation bolting, cripple wall bracing, and installing framing connectors. Our retrofit plans are tailored to your home’s structure, soil conditions, and municipal requirements.",
  },
  {
    question: "Do you handle engineering and permits?",
    answer:
      "Yes. Modern Build manages the full process<IN_CITY_ZIP> — including structural engineering, plan drafting, permit submission, and final inspections — ensuring your retrofit is fully code-compliant and city-approved.",
  },
  {
    question: "How long does the earthquake retrofit process take?",
    answer:
      "Most residential retrofits<IN_CITY_ZIP> are completed in 2 to 5 days. Larger projects, such as soft-story retrofits or multi-unit buildings, may take 1 to 2 weeks depending on scope and city inspection schedules.",
  },
  {
    question: "Do I need to leave my home during the retrofit?",
    answer:
      "In most cases, no. Earthquake retrofitting<IN_CITY_ZIP> is done in crawl spaces or basements and usually doesn’t disrupt daily living. We schedule work to minimize impact on your routine.",
  },
  {
    question: "Is financing available for earthquake retrofitting?",
    answer:
      "Yes. We offer financing options<IN_CITY_ZIP> with $0 down and low monthly payments. Pre-approval is quick and doesn’t impact your credit score. Ask us for details during your free consultation.",
  },
  {
    question: "Why choose Modern Build for earthquake retrofitting?",
    answer:
      "Modern Build connects homeowners in <IN_CITY_ZIP> with expert, licensed crews specializing in seismic retrofitting. Our trusted contractor partners use city-approved engineering and maintain clear communication from start to finish, delivering safe, reliable, and competitively priced upgrades.",
  },
  {
    question: "Can earthquake retrofitting lower my insurance premium?",
    answer:
      "Yes. Many insurance providers<IN_CITY_ZIP> offer discounts for homes that have been seismically retrofitted. After your retrofit is complete, we can provide documentation to submit to your insurer for potential savings.",
  },
];

export default FAQ;
